// extracted by mini-css-extract-plugin
export default {"p_content":"ce43928943"};